import React, { useState } from "react";
import "./TechRoadmap.css";

const TechRoadmap = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const docxRelativePath = "/data/FAIRPATTERNS_TECH_ROADMAP_v3.2.docx";
  const absoluteDocUrl = `${window.location.origin}${docxRelativePath}`;
  const googleViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(absoluteDocUrl)}&embedded=true`;

  const handleLoad = () => setLoading(false);
  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <div className="tech-roadmap-container">
      <div className="tech-roadmap-header">
        <div className="tech-roadmap-title-row">
          <span className="tech-roadmap-icon"></span>
          <div>
            <h1 className="tech-roadmap-title">Tech Roadmap</h1>
            <p className="tech-roadmap-subtitle">FAIRPATTERNS Technology Roadmap v3.2</p>
          </div>
        </div>
        <a
          href={docxRelativePath}
          download="FAIRPATTERNS_TECH_ROADMAP_v3.2.docx"
          className="tech-roadmap-download-btn"
        >
          Download DOCX
        </a>
      </div>

      <div className="tech-roadmap-viewer-wrapper">
        {loading && !error && (
          <div className="tech-roadmap-loading">
            <div className="tech-roadmap-spinner" />
            <p>Loading document�</p>
          </div>
        )}

        {!error ? (
          <iframe
            className="tech-roadmap-iframe"
            title="Tech Roadmap Document"
            src={googleViewerUrl}
            onLoad={handleLoad}
            onError={handleError}
            style={{ display: loading ? "none" : "block" }}
            allowFullScreen
          />
        ) : (
          <div className="tech-roadmap-error">
            <span className="tech-roadmap-error-icon">??</span>
            <h2>Unable to preview document</h2>
            <p>
              The document preview requires an internet connection and a publicly accessible URL.
              You can download the file directly instead.
            </p>
            <a
              href={docxRelativePath}
              download="FAIRPATTERNS_TECH_ROADMAP_v3.2.docx"
              className="tech-roadmap-download-btn"
            >
              ? Download DOCX
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default TechRoadmap;
